import React, { useState, useEffect } from "react";
import "./SellJob.css";
import { Row, Col, DatePicker, Select, Form } from "antd";
import calender from "../../../assets/img/calender.png";
import Editor from "../../../components/TextEditor/textEditor";
import moment from "moment";
import { right } from "@antv/g2plot/lib/plots/sankey/sankey";

const contractOptions = [{
  "IdealContractLengthId": 1,
  "IdealContractLengthName": "1 month",
  "IdealContractLengthValue": 1
}, {
  "IdealContractLengthId": 2,
  "IdealContractLengthName": "2 months",
  "IdealContractLengthValue": 2
}, {
  "IdealContractLengthId": 3,
  "IdealContractLengthName": "3 months",
  "IdealContractLengthValue": 3
}, {
  "IdealContractLengthId": 4,
  "IdealContractLengthName": "4 months",
  "IdealContractLengthValue": 4
}, {
  "IdealContractLengthId": 5,
  "IdealContractLengthName": "5 months",
  "IdealContractLengthValue": 5
}, {
  "IdealContractLengthId": 6,
  "IdealContractLengthName": "6 months",
  "IdealContractLengthValue": 6
}, {
  "IdealContractLengthId": 7,
  "IdealContractLengthName": "7 months",
  "IdealContractLengthValue": 7
}, {
  "IdealContractLengthId": 8,
  "IdealContractLengthName": "8 months",
  "IdealContractLengthValue": 8
}, {
  "IdealContractLengthId": 9,
  "IdealContractLengthName": "9 months",
  "IdealContractLengthValue": 9
}, {
  "IdealContractLengthId": 10,
  "IdealContractLengthName": "10 months",
  "IdealContractLengthValue": 10
}, {
  "IdealContractLengthId": 11,
  "IdealContractLengthName": "11 months",
  "IdealContractLengthValue": 11
}, {
  "IdealContractLengthId": 12,
  "IdealContractLengthName": "1 year",
  "IdealContractLengthValue": 12
}, {
  "IdealContractLengthId": 13,
  "IdealContractLengthName": "1+ years",
  "IdealContractLengthValue": 13
}, {
  "IdealContractLengthId": 14,
  "IdealContractLengthName": "Negotiable",
  "IdealContractLengthValue": 14
}, {
  "IdealContractLengthId": 15,
  "IdealContractLengthName": "13 weeks",
  "IdealContractLengthValue": 15
}, {
  "IdealContractLengthId": 16,
  "IdealContractLengthName": "1 Week",
  "IdealContractLengthValue": 16
}, {
  "IdealContractLengthId": 17,
  "IdealContractLengthName": "6 weeks",
  "IdealContractLengthValue": 17
}, {
  "IdealContractLengthId": 18,
  "IdealContractLengthName": "12 weeks",
  "IdealContractLengthValue": 18
}]

export const SellJob = React.memo((props) => {
  const { Option } = Select;

  const [idealStartDate, setIdealStartDate] = useState(props?.idealStartDate ? moment(props.idealStartDate) : moment());
  const [contractLength, setContractLength] = useState()
  const [currentDate, setCurrentDate] = useState(moment());

  const selectIdealStartDate = (e) => {
    setIdealStartDate(moment(e.toLocaleString()))
    // Ideal start Date
    if (e !== null) {
      props.setidealStartDate(e.toLocaleString());
    }
  };

  const contractLengthHandler = (value, object) => {
    setContractLength(value)
    // console.log('contractLength value', value)
    props.setcontractLength(value);
  };

  useEffect(() => {
    if (props.idealStartDate.length > 0) {
      setIdealStartDate(moment(props.idealStartDate))
      props.setidealStartDate(moment(props.idealStartDate));
    }
    else if (idealStartDate) {
      props.setidealStartDate(idealStartDate);
    }
  }, [props.idealStartDate])




  useEffect(() => {


    if (props?.jobOrderTypeName === "Permanent") {
      setContractLength(null);
    }

    else if (props?.contractLength) {
      setContractLength(
        contractOptions?.find(o => {
          return (o.IdealContractLengthId === props?.contractLength)
        })?.IdealContractLengthName
      )

    } else if (contractLength) {
      props.setcontractLength(contractOptions?.find(o => {
        return (o.IdealContractLengthName === contractLength)
      })?.IdealContractLengthId);
    }
  }, [props?.contractLength]);




  // console.log('Ideal Start Date>>>>>>>>>>>>>>>>>',props.idealStartDate);
  // console.log(props.error1, "error.1111......");
  // console.log(props.error2, "error...22222....");  
  // console.log(props.error3, "error...3333....");
  // console.log(props.setMsgCounter, "setMsgCounter.......");
  return (
    <>
    <div className="selljob-container-parent-div">
      <Row className="selljob-container">
        <div className="text_selljob">Ideal start date</div>
        <Row className="calender-container">
          <div className="icon-container">
            <div className="iconCont">
              <img src={calender} alt="calender" />
            </div>
          </div>
          <div className="date-container">
            <DatePicker
              value={
                idealStartDate
              }
              format="MMMM DD, YYYY"
              defaultValue={moment()}
              onChange={selectIdealStartDate}
              suffixIcon={null}
              style={{ background: "pink", width: "100%", height: "100%" }}
              className="dateP"
              disabledDate={(current) => {
                return moment().add(-1, "days") >= current;
              }}
            />
          </div>

          {props.error2?.length > 1 && (
            <span style={{ color: "red" }}>{props.error2} </span>
          )}
        </Row>
        {
          props?.jobOrderTypeName === "Permanent" ? <></> : <>
            <div className="text_selljob">Contract length</div>
            <div
              className="contract_container"
              style={{ backgroundColor: "white" }}
            >
              <Select
                placeholder="Select the contract length"
                value={props.EditBid ?
                  contractOptions?.find(o => {
                    return (o.IdealContractLengthId === props?.contractLength)
                  })?.IdealContractLengthName :
                  contractLength
                }
                className="contract_dropdown"
                onChange={contractLengthHandler}
              // defaultValue={"USD - $"}
              >
                {contractOptions.map((contractItem, i) => (
                  <Option key={i} value={contractItem.IdealContractLengthId} object={contractItem}>{contractItem.IdealContractLengthName}</Option>
                ))}
              </Select>
              <div style={{ marginTop: "0.1rem", marginBottom: "1rem" }}>
                {
                  props.error1?.length > 0 && (
                    <span style={{ color: "red" }}>{props.error1} </span>
                  )
                }
              </div>
            </div>
          </>
        }


        <div className="text_selljob" style={{ marginTop: "0.5rem" }}>
        Sell your gig
        </div>
        <Row className="editor-container-selljob">
          <Col span={24}>
            {/* <Form.Item
                    className="coverLetter"
                    name="coverLetter"
                    onChange={getMessage}
                    rules={
                      !message
                        ? [
                            {
                              required: true,
                              message: "This field is required.",
                            },
                          ]
                        : ""
                    }
                  > */}
            <Editor
              text={props.message}
              changeText={(text) => {
                props.setmessage(text);
                if(text){
                  props.setError3("")
                }
              }}
              counter={(val) => {
                props.setMsgCounter(val);
              }}
              FromSellJob={true}
              placeholder={'Highlight to possible candidates what responsibilities and skills you are looking for in a candidate and why they should consider working this job...'}
        
            />
            {props.error3?.length > 1 ? (
              <span style={{ color: "red" }}>{props.error3} </span>
            ) : null}
          </Col>
          {/* </Form.Item> */}
        </Row>
      </Row>
      </div>
    </>
  );
})
